import { Component, Input, Output, EventEmitter } from '@angular/core';
@Component({
  selector: 'app-scrollbar',
  templateUrl: './scrollbar.component.html',
  styleUrls: ['./scrollbar.component.scss']
})
export class ScrollbarComponent {
  @Input() scrollThumbWidth: number = 10;
  @Input() scrollThumbLeft: number = 0;
  @Output() scrollLeft = new EventEmitter<void>();
  @Output() scrollRight = new EventEmitter<void>();

  onScrollLeft() {
    this.scrollLeft.emit(); 
  }

  onScrollRight() {
    this.scrollRight.emit();
  }

}
